export const colors = {
  black: "#000000",
  grey90: "#181818",
  grey80: "#333333",
  grey60: "#585858",
  grey45: "#8c8c8c",
  grey30: "#b2b2b2",
  grey15: "#d9d9d9",
  grey10: "#e5e5e5",
  grey05: "#f2f2f2",
  white: "#ffffff",
  bsRødDark: "#870010",
  bsRødMedium: "#d53d40",
  accentPurple: "#331433",
  accentPeach: "#ffba99",
  accentGreen: "#003b29",
  accentBlueDark: "#001740",
  accentBlueMedium: "#5996de",
  accentYellow: "#ffc970",
  lightBlue: "#dbe8ef",
  lightGreen: "#dbe0db",
  lightPeach: "#f4e7de",
  lightPurple: "#ece8f3",
  statusRed: "#ad313c",
  statusYellow: "#bc5600",
  statusGreen: "#24845b",
  statusGreenLight: "#edf4f1",
  statusRedLight: "#f8efef",
  statusYellowLight: "#fff6e4",
  neptune: {
    "100": "#CFE6E8",
    "200": "#9FCDD2",
    "300": "#6FB5BB",
    "400": "#3F9CA5",
    "500": "#0F838E",
    "600": "#0C6972",
    "700": "#094F55",
    "800": "#063439",
    "900": "#031A1C",
  },
};
